import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50 font-heading">
                黑
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              {siteInfo.tagline}。集中归档官方声明、辟谣澄清与公告通知原文。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="font-heading text-sm font-bold text-background-50">导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">首页</Link></li>
              <li><Link to="/statements" className="text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">声明公告库</Link></li>
              <li><Link to="/faq" className="text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">常见问题</Link></li>
              <li><Link to="/about" className="text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">关于我们</Link></li>
              <li><Link to="/contact" className="text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">联系我们</Link></li>
            </ul>
          </nav>

          <nav aria-label="公告分类">
            <h3 className="font-heading text-sm font-bold text-background-50">公告分类</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/statements?category=${cat.id}`}
                    className="text-background-200/80 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">联系方式</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-start gap-2">
                <span className="flex h-5 w-5 items-center justify-center"><i className="ri-mail-line" /></span>
                <span className="break-all">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-5 w-5 items-center justify-center"><i className="ri-time-line" /></span>
                <span>{siteInfo.serviceHours}</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-5 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              提交核实线索
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/20 pt-6 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name}. 保留所有权利。内容以原文为准，请以最新公告为准。</p>
          <p>本页面仅用于信息归档与核实说明，不构成任何形式的担保或承诺。</p>
        </div>
      </div>
    </footer>
  );
}